module.exports = __webpack_public_path__ + "static/img/pic_tupianyasuo_big.2146a6e0.png";